import type { ResumeData } from "@stylingcv/schema";
// @ts-ignore
import * as pdfjsLib from "pdfjs-dist";
import type { Parser } from "../interfaces/parser";

// Import the worker URL properly for Vite
// @ts-ignore
import pdfWorker from "pdfjs-dist/build/pdf.worker.min.mjs?url";

// Set up the worker for PDF.js
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

export interface PDFData {
  text: string;
  numpages?: number;
  info?: {
    Title?: string;
    Author?: string;
    Subject?: string;
    Keywords?: string;
  };
}

export class PDFParser implements Parser<PDFData, PDFData, ResumeData> {
  constructor() {}

  readFile(file: File): Promise<PDFData> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async () => {
        try {
          const arrayBuffer = reader.result as ArrayBuffer;

          // Load the PDF document
          const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

          // Extract text from all pages
          let fullText = "";
          const numPages = pdf.numPages;

          for (let pageNum = 1; pageNum <= numPages; pageNum++) {
            const page = await pdf.getPage(pageNum);
            const textContent = await page.getTextContent();
            const pageText = textContent.items
              .map((item: any) => item.str)
              .join(" ");
            fullText += pageText + "\n";
          }

          // Get PDF metadata
          const metadata = await pdf.getMetadata();

          resolve({
            text: fullText,
            numpages: numPages,
            info: metadata.info as any,
          });
        } catch (error) {
          reject(new Error(`Failed to parse PDF: ${error instanceof Error ? error.message : "Unknown error"}`));
        }
      };

      reader.onerror = () => {
        reject(new Error("Failed to read the PDF file"));
      };

      reader.readAsArrayBuffer(file);
    });
  }

  validate(data: PDFData): PDFData {
    if (!data.text || data.text.trim().length === 0) {
      throw new Error("PDF file contains no extractable text");
    }
    return data;
  }

  convert(data: PDFData): ResumeData {
    // This will be handled by the AI service
    // For now, we'll throw an error as direct conversion is not possible
    throw new Error("PDF conversion requires AI processing. Please use the AI extraction service.");
  }
}